export default __webpack_public_path__ + "static/media/coal_work.46794804.jpg";